import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useContext, createContext, useState } from "react";
import { getstg } from '../../utils';
import * as API from '../API';
const UserContext = createContext(null);
export const useUserContext = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error("UserContext must be used within a UserContextProvider");
    }
    return context;
};
export const UserContextProvider = ({ debug, children }) => {
    const [userContext, setUserContext] = useState(null);
    const fetchAnalyses = () => {
        API.userspaceFetchAnalyses()
            .then((analyses) => {
            setUserContext((prev) => {
                var _a, _b, _c;
                if (!prev || !Array.isArray(analyses))
                    return prev;
                return Object.assign(Object.assign({}, prev), { userData: Object.assign(Object.assign({}, ((_a = prev.userData) !== null && _a !== void 0 ? _a : {})), { analyticsRoom: Object.assign(Object.assign({}, ((_c = (_b = prev.userData) === null || _b === void 0 ? void 0 : _b.analyticsRoom) !== null && _c !== void 0 ? _c : {})), { analyses: analyses }) }) });
            });
        });
    };
    useEffect(() => {
        fetchAnalyses();
    }, []);
    const saveUserContext = (ctx) => {
        setUserContext(ctx);
    };
    const refreshUserContext = () => {
        fetchAnalyses();
    };
    useEffect(() => {
        const stg = getstg();
        const uctx = {
            user: stg.user
        };
        setUserContext(uctx);
    }, []);
    useEffect(() => {
        if (userContext === null || userContext === void 0 ? void 0 : userContext.userData) {
            // TODO: Flush user profile data to server
        }
    }, [userContext === null || userContext === void 0 ? void 0 : userContext.userData]);
    return (_jsx(UserContext.Provider, { value: { data: userContext, save: saveUserContext, refresh: refreshUserContext }, children: children }));
};
